import _ from "lodash"
import DynamicFormField from "./DynamicFormField.model"

// test: jest src/models/__tests__/Collection.model.spec.js
class Collection {
  constructor (_rawData) {
    this.collection = _rawData
  }

  textForOption (collectionItemId) {
    const mainDisplayFieldIds = DynamicFormField.fromArray(_.get(this.collection, 'config.fields', []))
      .filter(fieldModel => fieldModel.main_display)
      .map(fieldModel => fieldModel._id)

    const collectionItem = _.get(this.collection, 'items', []).find(({ id }) => id === collectionItemId)

    let textForOption = _.get(collectionItem, 'data[0].value')
    if (mainDisplayFieldIds.length > 0) {
      textForOption = _.get(collectionItem, 'data', [])
        .filter((field) => mainDisplayFieldIds.includes(field.field_id))
        .map(field => field.value)
        .join(' ')
    }

    if (!collectionItem?.is_enabled) {
      textForOption = `(已停用)${textForOption}`
    }

    return textForOption
  }
}

export default Collection
